module.exports = __webpack_public_path__ + "static/media/receive_pack.86d244d2.svg";